import { getPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
export const CHART_KEY_PREFIX = 'chart-key-';
export const CHART_ID_PREFIX = 'chart-container-';
export const METRIC_CARD_PREFIX = 'metric-card-';

export const getSelectedChartId = (selectedMetric) => {
  const metricName = getPercentageMetricByKey({
    metricKey: selectedMetric,
    defaultValue: selectedMetric,
  });
  const cleanedId = metricName.replace(/\W/g, '_');
  return `${CHART_ID_PREFIX}${cleanedId}`;
};
